// extracted by mini-css-extract-plugin
export default {"receiveMessage":"index_receiveMessage__+Xd24"};